module.exports = __webpack_public_path__ + "img/logo-telemeteri.002ea422.png";